import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Tag, Button } from "antd";
import EditTagModal from "./EditTagModal";
import DeleteTagModal from "./DeleteTagModal";
import { TagIconPreview } from "./IconPicker";

export default function GridView({ searchText }) {
  const { tagsList, selectedScope } = useSelector((state) => ({
    tagsList: state.tags?.tagsList || [],
    selectedScope: state.tags?.selectedScope || "all",
  }));

  const [editTag, setEditTag] = useState(null);
  const [deleteTagInfo, setDeleteTagInfo] = useState(null);

  const filteredTags = tagsList.filter((tag) => {
    const tagScope = (tag.scope || "global").toLowerCase();
    const matchesScope = selectedScope === "all" || tagScope === selectedScope;
    const tagSlug = tag.slug || tag.code || "";
    const matchesSearch =
      !searchText ||
      tag.name.toLowerCase().includes(searchText.toLowerCase()) ||
      tagSlug.toLowerCase().includes(searchText.toLowerCase());
    return matchesScope && matchesSearch;
  });

  return (
    <>
      <div className="row g-3">
        {filteredTags.length === 0 ? (
          <div className="col-12 text-center py-5 text-muted">
            <i className="la la-tags fs-1 d-block mb-2 text-secondary" />
            <p className="mb-0">No tags found matching current criteria.</p>
          </div>
        ) : (
          filteredTags.map((tag) => {
            const scopeVal = (tag.scope || "global").toUpperCase();
            const active = tag.isActive !== undefined ? Boolean(tag.isActive) : tag.status !== "inactive";
            const tagColor = tag.color || tag.badgeColor || "#0d6efd";
            const displaySlug = tag.slug || tag.code || "-";

            return (
              <div key={tag._id || tag.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                <div
                  className="card h-100 shadow-sm border-0"
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    borderTop: `4px solid ${tagColor}`,
                  }}
                >
                  <div className="card-body p-3 d-flex flex-column justify-content-between">
                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <Tag color="cyan" style={{ borderRadius: "10px", fontSize: "10px", fontWeight: 600 }}>
                          {scopeVal}
                        </Tag>
                        <Tag color={active ? "green" : "red"} style={{ borderRadius: "10px", fontSize: "10px", fontWeight: 600 }}>
                          {active ? "ACTIVE" : "INACTIVE"}
                        </Tag>
                      </div>

                      <div className="my-2">
                        <TagIconPreview
                          icon={tag.icon}
                          badgeColor={tagColor}
                          name={tag.name}
                        />
                      </div>

                      <div className="mt-2">
                        <small className="text-muted d-block mb-1">
                          Slug: <code>{displaySlug}</code>
                        </small>
                        <p className="text-secondary small mb-2 text-truncate-2" style={{ minHeight: "36px" }}>
                          {tag.description || "No description provided."}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between pt-2 border-top mt-2">
                      <span className="small text-muted fw-bold">
                        <i className="la la-link me-1" />
                        {tag.courseCount || 0} assigned
                      </span>
                      <div className="d-flex gap-1">
                        <Button
                          type="text"
                          size="small"
                          onClick={() => setEditTag(tag)}
                          icon={<i className="la la-edit text-primary fs-5" />}
                        />
                        <Button
                          type="text"
                          size="small"
                          onClick={() => setDeleteTagInfo(tag)}
                          icon={<i className="la la-trash text-danger fs-5" />}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {editTag && (
        <EditTagModal
          visible={!!editTag}
          info={editTag}
          onCancel={() => setEditTag(null)}
        />
      )}

      {deleteTagInfo && (
        <DeleteTagModal
          visible={!!deleteTagInfo}
          info={deleteTagInfo}
          onCancel={() => setDeleteTagInfo(null)}
        />
      )}
    </>
  );
}
